import { AttributeValue, CartLine } from '@msdyn365-commerce/retail-proxy';
import { IActionContext } from '@msdyn365-commerce/core-internal';
import { IProductCatalogPair, loadAttributesForProducts, ProductAttributesMap } from './product-attributes-helpers';
import { IAny, ICoreContext, IGeneric } from '@msdyn365-commerce/core';

export function isEVoucherValidationEnabled(context: ICoreContext<IGeneric<IAny>>): boolean {
    return !!context.app.config?.eVoucherAttributeName;
}

export const hasEVoucherAttribute = (attrs: AttributeValue[], eVoucherAttr: string): boolean =>
    attrs.some(a => a.Name?.toUpperCase() === eVoucherAttr.toUpperCase());

const areAllProductsEVouchers = (cartProductIds: number[], attrsMap: ProductAttributesMap, eVoucherAttr: string): boolean => {
    return cartProductIds.every(id => {
        const attrs = attrsMap.get(id) ?? [];
        return hasEVoucherAttribute(attrs, eVoucherAttr);
    });
};

export const isCartContainOnlyEVoucherProducts = async (
    cartLines: CartLine[],
    eVoucherAttributeName: string,
    channelId: number,
    actionContext: IActionContext
): Promise<boolean> => {
    if (!cartLines.length || !eVoucherAttributeName) {
        return false;
    }

    const pairs: IProductCatalogPair[] = cartLines
        .filter(l => l.ProductId)
        .map(l => ({ productId: l.ProductId!, catalogId: l.CatalogId ?? 0 }));

    if (!pairs.length) {
        return false;
    }

    const productIds = [...new Set(pairs.map(p => p.productId))];
    const attrsMap = await loadAttributesForProducts(pairs, channelId, actionContext);

    return areAllProductsEVouchers(productIds, attrsMap, eVoucherAttributeName);
};
